import * as React from 'react'
import * as Tooltip from 'react-tooltip'
import { ReactSingleSelect } from '../../../../../../components/ReactSelect'
import { POUpdate, POReceiptExtension } from './ImportPOModal'
import { Upload, Icon } from 'antd'

import { UploadChangeParam } from 'antd/lib/upload'
import { UploadFile } from 'antd/lib/upload/interface'
import { BLAZE_COMPANY } from '../../../../../../constants/general'

type UploadMethods = 'gmail' | 'mailOnMac'

interface Props {
  onDrop: (file: UploadFile<any>) => void
  uploadType: POUpdate
}

interface State {
  uploadMethod: UploadMethods
}

export class ReceiptDropzone extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      uploadMethod: 'gmail',
    }
  }

  get receiptUploadOptions(): Array<{ value: UploadMethods; label: string }> {
    return [
      { label: 'Gmail', value: 'gmail' },
      { label: 'Mail (Mac)', value: 'mailOnMac' },
    ]
  }

  get uploadGif(): JSX.Element {
    const { uploadMethod } = this.state
    let gifUrl

    switch (uploadMethod) {
      case 'gmail':
        gifUrl =
          'https://res.cloudinary.com/get-greenline/image/upload/v1566414237/greenline/gmail_receipt_import_instruction.gif'
        break
      case 'mailOnMac':
        gifUrl =
          'https://res.cloudinary.com/get-greenline/image/upload/v1566422306/greenline/mail_on_mac_receipt_import_instruction.gif'
        break
    }

    return <img className='w-100 border border-white rounded' src={gifUrl} />
  }

  get dropzoneDescription() {
    const { uploadType } = this.props

    if (uploadType === 'AB') {
      return (
        <>
          <div>
            Click or drag the <strong>[Order number]_PackList.xlsx</strong> file to upload
          </div>

          <div className='p-3' data-for='aglc-example' data-tip>
            <b>See example</b>
            <Tooltip id='aglc-example' place='bottom'>
              <p>**Red boxes indicate mandatory fields</p>

              <div className='mb-4'>
                <img
                  src={require('../../../../../../images/aglc_receiptv2_example_1.png').default}
                  style={{
                    width: '70rem',
                    height: 'auto',
                  }}
                />
              </div>
              <div>
                <img
                  src={require('../../../../../../images/aglc_receiptv2_example_2.png').default}
                  style={{
                    width: '70rem',
                    height: 'auto',
                  }}
                />
              </div>
            </Tooltip>
          </div>
        </>
      )
    } else if (uploadType === 'BC') {
      return <div>Click or drag the xml, xls, or xlsx file to upload</div>
    } else if (uploadType === 'ON') {
      return (
        <>
          <div>Click or drag the xls or xlsx file to upload</div>
          <div className='p-3' data-for='ocs-example' data-tip>
            <b>See example</b>
            <Tooltip id='ocs-example' place='bottom'>
              <p>**Red boxes indicate mandatory fields</p>

              <div className='mb-4'>
                <img
                  src='https://res.cloudinary.com/get-greenline/image/upload/v1580948427/greenline/ocs_receipt_example_1.png'
                  style={{
                    width: '70rem',
                    height: 'auto',
                  }}
                />
              </div>

              <div>
                <img
                  src='https://res.cloudinary.com/get-greenline/image/upload/v1580948427/greenline/ocs_receipt_example_2.png'
                  style={{
                    width: '70rem',
                    height: 'auto',
                  }}
                />
              </div>
            </Tooltip>
          </div>
        </>
      )
    } else if (uploadType === BLAZE_COMPANY) {
      return <div>Click or drag file to upload</div>
    }
  }

  get acceptFileType() {
    switch (this.props.uploadType) {
      case 'AB':
        return `.${POReceiptExtension.ABxls}, .${POReceiptExtension.ABxlsx}`
      case 'BC':
        return `.${POReceiptExtension.BC}, .${POReceiptExtension.BCxlsx}, .${POReceiptExtension.BCxml}`
      case 'ON':
        return `.${POReceiptExtension.ONxls}, .${POReceiptExtension.ONxlsx}`
      default:
        return `.${POReceiptExtension.BLAZE_COMPANY}`
    }
  }

  render() {
    const { uploadType } = this.props
    return (
      <>
        <Upload.Dragger
          name='file'
          multiple={false}
          onChange={(info: UploadChangeParam<UploadFile<any>>) => this.props.onDrop(info.file)}
          accept={this.acceptFileType}
        >
          <p className='ant-upload-drag-icon'>
            <Icon type='inbox' />
          </p>
          <div className='ant-upload-text'>{this.dropzoneDescription}</div>
        </Upload.Dragger>
      </>
    )
  }
}
